import React from 'react';
import { Provider, ProviderProps } from 'react-redux';
import { ConnectedRouter, ConnectedRouterProps } from 'connected-react-router';
import { renderRoutes } from 'react-router-config';
import { Title } from '../../withTitle';
import { AppProviders } from '../../contexts/index';
import { getRoutesWithStore } from '../../routes';
import '@spotify-internal/encore-web/css/encore-anchor-light-theme.css';

type AppEntryProps = {
  store: ProviderProps['store'];
  history: ConnectedRouterProps<any>['history'];
};

const AppEntry = ({ store, history }: AppEntryProps) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppProviders>
        <div className="encore-anchor-light-theme">
          <Title />
          {renderRoutes(getRoutesWithStore(store) as any)}
        </div>
      </AppProviders>
    </ConnectedRouter>
  </Provider>
);

export { AppEntry };
